import React, {Component} from 'react';
import {Field} from 'redux-form';
import {Card, CardBody, Button, ButtonGroup} from 'reactstrap';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import LoadingIcon from 'mdi-react/LoadingIcon';
import {withTranslation} from "react-i18next";

class PublishCard extends Component {

    render() {

        const {handlePublish, handleSaveDraft, draftId, inProgress, status, permlink, domain, t} = this.props;

        return (
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">{t('write.publish.title')}</h5>
                        <h5 className="subhead">{t('write.publish.subtitle')}</h5>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field
                                name="decline_reward"
                                component={renderCheckBoxField}
                                label={t('write.publish.decline_reward')}
                                className="colored-click"
                                disabled={status === 'published'}
                            />
                        </div>
                    </div>
                    <div className="form__form-group">

                        {status !== 'published' && <ButtonGroup className="btn-group--justified">
                            <Button color="primary" type="submit"
                                    onClick={handleSaveDraft}> {draftId ? t('write.publish.button_update_draft') : t('write.publish.button_save_draft')}</Button>
                        </ButtonGroup>}

                        {status === 'published' && <ButtonGroup className="btn-group--justified">
                            <Button color="primary" type="submit"
                                    onClick={() => window.open(`https://${domain}/${permlink}`, '_blank')}>{t('write.publish.button_visit')}</Button>
                        </ButtonGroup>}

                        <ButtonGroup className="btn-group--justified">
                            <Button
                                color="success"
                                type="submit"
                                onClick={() => {
                                    if (!inProgress) {
                                        handlePublish()
                                    }
                                }}
                                className="expand expand--load"
                            >
                                {inProgress && <LoadingIcon/>}
                                {status === 'published' && t('write.publish.button_update')}
                                {status !== 'published' && t('write.publish.button_publish')}
                            </Button>
                        </ButtonGroup>

                        {this.props.error &&
                        <span className="form__form-group-error">{t('write.publish.could_not_send_an_article')}</span>}

                    </div>
                </CardBody>
            </Card>
        )

    }

}

export default withTranslation('dashboard')(PublishCard);
